export const SET_USERS = 'SET_USERS';
export const setUsersAction = (users) => ({
  type: SET_USERS,
  payload: users,
});
